import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {Contact} from "./Contact";
import {FormatTypes} from "../core/Formater";

export class Customer extends BaseModel {

	constructor () {
		super()
	}

	id: string
	title: string
	vatId: string
	internalId: string
	companyId: string
	email: string
	address: string
	business: string
	phone: string
	representative: string
	webAddress: string
	saldo: number
	contacts: Contact[]
}

// export class CustomerDescriptor extends BaseModelDescriptor {
// 	static id: AttributeDescriptor = {validation: []}
// 	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
// 	static email: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.EMAIL]}
// 	static address: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
// 	static phone: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.PHONE]}
// 	static saldo: AttributeDescriptor = {validation:[], format: FormatTypes.PRICE}
// 	static vatId: AttributeDescriptor = {validation:[ValidationTypes.REQUIRED, ValidationTypes.NUMERIC, ValidationTypes.VAT_ID]}
// 	static companyId: AttributeDescriptor = {validation:[ValidationTypes.REQUIRED, ValidationTypes.NUMERIC, ValidationTypes.COMPANY_ID]}
// }

export class CustomerDescriptor extends BaseModelDescriptor {
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static email: AttributeDescriptor = {validation: [ ]}
	static address: AttributeDescriptor = {validation: []}
	static phone: AttributeDescriptor = {validation: []}
	static saldo: AttributeDescriptor = {validation:[], format: FormatTypes.PRICE}
	static vatId: AttributeDescriptor = {validation:[]}
	static companyId: AttributeDescriptor = {validation:[]}
}
